import React from "react";
import { Box } from "@mui/material";
import logo from "./../recursos/logo-diferente.png";

const Logo = () => {
    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <img
                style={{
                    width: "100%",
                    maxWidth: 380,
                    height: "auto",
                    display: "block",
                }}
                src={logo}
                alt="Logo"
            />
        </Box>
    );
};

export default Logo;
